import { Section } from "@/components/Section";

const IMG = "https://customer-assets-wrfwihn1.emergentagent.net/job_asilo-peramore/artifacts/y2tohbw1_0d25e450-923c-4a23-8083-73e38fcc9564.jpeg";

export const Iscrizioni = () => {
  const go = () => document.getElementById("richiedi-info")?.scrollIntoView({ behavior: "smooth" });
  return (
    <Section id="iscrizioni" eyebrow="Iscrizioni" title="Entra a far parte del nostro nido" image={IMG} reverse tint="bg-[#f7f0e3]">
      <p>
        L'Asilo Nido Per Amore accoglie i bambini in un percorso educativo pensato con cura. La domanda di
        iscrizione può essere presentata presso la Direzione dell'asilo nido in qualsiasi periodo dell'anno,
        in base alla disponibilità dei posti.
      </p>
      <p>
        Saremo felici di accoglierti per una visita e mostrarti i nostri spazi. Compila il modulo qui sotto
        e ti ricontatteremo con tutte le informazioni su iscrizioni, rette e disponibilità.
      </p>
      <button
        data-testid="iscrizioni-cta"
        onClick={go}
        className="mt-2 rounded-full bg-rose-500 text-white px-7 py-3.5 font-700 hover:bg-rose-600 hover:-translate-y-0.5 transition-all shadow-lg"
      >
        Richiedi informazioni
      </button>
    </Section>
  );
};
